export default "__VITE_ASSET__BEOYjaoa__"